export default __webpack_public_path__ + "static/media/logo-light.b350299c.svg";